import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import CustomSelect from "./Map/CustomerDropdown";
import { SelectInput } from "../Inquiary/components/common/FormInput";
import { useMasters } from "../../hooks/useMasters";

const withCurrentValue = (options, value) => {
  if (!value || options.some((item) => item.value === value)) return options;
  return [...options, { value, label: value }];
};

export default function MasterSelect({
  group,
  fallback = [],
  value,
  onChange,
  placeholder,
  disabled,
  className,
  variant = "custom",
  allowedValues,
}) {
  const loaded = useMasters(group, fallback);
  const filtered = allowedValues?.length
    ? loaded.filter((item) => allowedValues.includes(item.value))
    : loaded;
  const options = withCurrentValue(filtered, value);
  const children = (
    <>
      {placeholder ? <option value="">{placeholder}</option> : null}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </>
  );

  if (variant === "inquiry") {
    return (
      <SelectInput value={value} onChange={onChange} disabled={disabled} className={className}>
        {children}
      </SelectInput>
    );
  }

  return (
    <CustomSelect value={value} onChange={onChange} disabled={disabled} className={className}>
      {children}
    </CustomSelect>
  );
}

export function MasterAutocomplete({
  group,
  fallback = [],
  value,
  onChange,
  placeholder = "Select",
  label,
  disabled,
  size = "small",
}) {
  const options = useMasters(group, fallback);
  const values = options.map((item) => item.value);
  const all = value && !values.includes(value) ? [...values, value] : values;

  return (
    <Autocomplete
      value={value || null}
      options={all}
      disabled={disabled}
      getOptionLabel={(opt) => options.find((item) => item.value === opt)?.label || opt || ""}
      onChange={onChange}
      slotProps={{
        popper: {
          sx: { zIndex: 20000 },
        },
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={placeholder} size={size} />
      )}
    />
  );
}
